import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import projectList from "../views/projectList";
import workbench from "../views/workbench";
// 照片
import photoList from "../views/photo/list";
import photoUpload from "../views/photo/upload";

const routes = [
	{path: '*',redirect: '/projectList'},
	{path: '/projectList/:appid?/:secretkey?', component: projectList, name: 'projectList', meta: {title: '项目列表'}},
	{path: '/workbench', component: workbench, name: 'workbench', meta: {title: '工作台'}},
	
	{path: '/photoList', component: photoList, name: 'photoList', meta: {title: '照片列表'}},
	{path: '/photoUpload', component: photoUpload, name: 'photoUpload', meta: {title: '照片上传'}},
	
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
export default router
